

import React from "react";

const durations = [
  { id: 1, label: "3 Month" },
  { id: 2, label: "6 Month" },
  { id: 3, label: "9 Month" },
  { id: 4, label: "12 Month" },
];

const MSelectDuration = ({ closeModal }) => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-400 to-[#FF9630] p-4 flex items-center">
        <button onClick={closeModal} className="text-white">
          <span className="text-2xl font-semibold">&larr;</span>
        </button>
        <h2 className="ml-4 text-white text-lg font-semibold">SELECT DURATION</h2>
      </div>

      {/* Duration List */}
      <div className="p-6">
        {durations.map((duration) => (
          <div key={duration.id} className="flex  justify-between border-b py-4">
            <span className="text-gray-700 text-base">{duration.label}</span>
            <input type="checkbox" className="form-checkbox h-5 w-5 text-[#FF9630] rounded-md cursor-pointer" />
          </div>
        ))}
      </div>

      {/* Buttons */}
      <div className="flex justify-between p-4 bg-white">
        <button className="border-2 border-[#FF9630] text-[#FF9630] font-medium py-2 px-6 rounded-md hover:bg-orange-100">
          CLEAR
        </button>
        <button className="bg-[#FF9630] text-white font-medium py-2 px-6 rounded-md hover:bg-orange-600" onClick={closeModal}>
          ADD TO FILTER
        </button>
      </div>
    </div>
  );
};

export default MSelectDuration;
